export const LINKS = [
  {
    title: "Home",
    id: "Home",
    to: "/#home",
  },
  {
    title: "About",
    id: "About",
    to: "/#aboutus",
  },
  {
    title: "Service",
    id: "Service",
    to: "/#service",
  },
  {
    title: "Product",
    id: "Product",
    to: "/#prod",
  },
  {
    title: "Contact Us",
    id: "Contact Us",
    to: "/#contact",
  },
];
